export default __webpack_public_path__ + "static/media/inspector-text-align-justify.2b63f998.svg";